import React from 'react';
import {
  FaFilePdf,
  FaFileWord,
  FaFilePowerpoint,
  FaFileExcel,
  FaFileAlt,
  FaFileImage,
  FaFileVideo,
  FaFileAudio,
  FaFileArchive,
  FaFileCode,
  FaFile,
  FaGlobe,
  FaBuilding,
  FaClipboardList,
} from 'react-icons/fa';
import { SiJavascript, SiTypescript, SiCss3, SiJson, SiPython, SiCplusplus } from 'react-icons/si';
import { extensionFromUrl } from '../utils/documentLinks';

interface FileTypeIconProps {
  url: string;
  className?: string;
}

const FileTypeIcon: React.FC<FileTypeIconProps> = ({ url, className }) => {
  const getIcon = (): React.ReactElement => {
    try {
      const cleanUrl = url.split('?')[0];
      const parts = cleanUrl.split('/');
      const fullFilename = parts[parts.length - 1];

      if (!fullFilename) {
        return <FaGlobe className={className} />;
      }

      const extension = decodeURIComponent(fullFilename).toLowerCase().split('.').pop();

      switch (extension) {
        case 'pdf':
          return <FaFilePdf className={className} />;
        case 'doc':
        case 'docx':
          return <FaFileWord className={className} />;
        case 'ppt':
        case 'pptx':
          return <FaFilePowerpoint className={className} />;
        case 'xls':
        case 'xlsx':
          return <FaFileExcel className={className} />;
        case 'txt':
          return <FaFileAlt className={className} />;
        case 'html':
        case 'htm':
          return <FaGlobe className={className} />;
        case 'aspx':
          return <FaGlobe className={className} />;
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
        case 'bmp':
        case 'svg':
          return <FaFileImage className={className} />;
        case 'mp4':
        case 'avi':
        case 'mov':
        case 'wmv':
          return <FaFileVideo className={className} />;
        case 'mp3':
        case 'wav':
        case 'wma':
          return <FaFileAudio className={className} />;
        case 'zip':
        case 'rar':
        case '7z':
        case 'tar':
          return <FaFileArchive className={className} />;
        case 'js':
          return <SiJavascript className={className} />;
        case 'ts':
          return <SiTypescript className={className} />;
        case 'jsx':
        case 'tsx':
          return <FaFileCode className={className} />;
        case 'css':
        case 'scss':
          return <SiCss3 className={className} />;
        case 'json':
          return <SiJson className={className} />;
        case 'xml':
          return <FaFileCode className={className} />;
        case 'py':
          return <SiPython className={className} />;
        case 'cpp':
        case 'c':
          return <SiCplusplus className={className} />;
        default:
          if (url.includes('sharepoint.com')) {
            if (url.includes('/sites/') || url.includes('/SitePages/')) {
              return <FaBuilding className={className} />;
            }
            if (url.includes('/Lists/') || url.includes('/_layouts/')) {
              return <FaClipboardList className={className} />;
            }
          }
          return <FaFile className={className} />;
      }
    } catch {
      return <FaFile className={className} />;
    }
  };

  return getIcon();
};

export default FileTypeIcon;

export function getFileTypeClass(url: string): string {
  const ext = extensionFromUrl(url);
  switch (ext) {
    case 'pdf':
      return 'document-link-card-icon--pdf';
    case 'doc':
    case 'docx':
      return 'document-link-card-icon--word';
    case 'ppt':
    case 'pptx':
      return 'document-link-card-icon--ppt';
    case 'xls':
    case 'xlsx':
      return 'document-link-card-icon--excel';
    default:
      return 'document-link-card-icon--default';
  }
}
